export default __webpack_public_path__ + "static/logo-db24c1d8c5f355978eaa5e43e4f45d84.png";